/* TrackDNA — fitment popup.
 *
 * Every link to the Shop by Vehicle page opens the popup instead of navigating, so
 * setting or changing a vehicle never costs a page load. That covers the main nav, the
 * hero button, the footer and the saved-vehicle bar's "Change vehicle" in one place,
 * because all four point at the same URL.
 *
 * PROGRESSIVE ENHANCEMENT. Without this script every one of those links still navigates
 * to the page, exactly as the markup says. Nothing here is required for the link to work.
 *
 * WHEN IT DOES NOT OPEN. On Home the app moves the form out of the modal and into the
 * hero card, leaving the modal empty. Opening an empty dialog would be worse than the
 * link, so when a form is already visible on the page the script scrolls to it and
 * focuses the first field instead.
 *
 * The EasySearch garage overlay would be the natural home for this, but it is behind a
 * plan upgrade on this store. The check is kept so the popup defers to it if that ever
 * changes.
 */
(function () {
  "use strict";

  var VEHICLE_PATH = "/pages/shop-by-vehicle";
  var FOCUSABLE = 'a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])';

  var lastFocused = null;

  function modal() {
    return document.querySelector("[data-fitment-modal]");
  }

  /* A form is "on the page" only if it is actually visible — the copy inside the closed
     modal does not count, or the popup would never open. */
  function visibleForm() {
    var candidates = document.querySelectorAll(".fitment-form-target, .easysearch-main-widget");
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.closest("[data-fitment-modal]")) continue;
      if (el.getBoundingClientRect().height > 0) return el;
    }
    return null;
  }

  function isOpen() {
    var m = modal();
    return !!m && !m.hidden;
  }

  function open() {
    var m = modal();
    if (!m || isOpen()) return false;

    /* An empty modal is worse than the link it replaced. */
    if (!m.querySelector(".easysearch-select-holder select, .easysearch-main-widget")) return false;

    lastFocused = document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add("fitment-modal-open");

    var first = m.querySelector("select") || m.querySelector(FOCUSABLE);
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    return true;
  }

  function close() {
    var m = modal();
    if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.classList.remove("fitment-modal-open");
    if (lastFocused && typeof lastFocused.focus === "function") {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
    }
    lastFocused = null;
  }

  function scrollToForm(form) {
    form.scrollIntoView({ behavior: "smooth", block: "center" });
    var field = form.querySelector("select");
    if (!field) return;
    window.setTimeout(function () {
      try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
    }, 450);
  }

  /* One delegated listener rather than wiring each link, so nav, hero, footer, the bar
     and anything added later are all covered without re-binding. */
  document.addEventListener("click", function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; // let people open a tab

    var link = event.target.closest ? event.target.closest("a[href]") : null;
    if (!link) return;
    if (link.target && link.target !== "_self") return;

    var href = link.getAttribute("href") || "";
    if (href.indexOf(VEHICLE_PATH) === -1) return;

    var garage = document.querySelector(".easysearch-garage-btn-open, .easysearch-garage-toggle");
    if (garage) {
      event.preventDefault();
      garage.click();
      return;
    }

    var form = visibleForm();
    if (form) {
      event.preventDefault();
      scrollToForm(form);
      return;
    }

    if (open()) event.preventDefault();
    // otherwise fall through and let the link navigate
  });

  document.addEventListener("click", function (event) {
    if (!event.target.closest) return;
    if (event.target.closest("[data-fitment-modal-close], [data-fitment-modal-scrim]")) close();
  });

  document.addEventListener("keydown", function (event) {
    if (!isOpen()) return;

    if (event.key === "Escape") {
      close();
      return;
    }

    if (event.key !== "Tab") return;

    /* Keep focus inside the dialog while it is open. */
    var m = modal();
    var items = Array.prototype.slice.call(m.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* Once a vehicle is chosen the app navigates, but close anyway so the dialog is never
     left open behind a soft update. */
  document.addEventListener("easysearch_params_saved", close);
})();
